import axios from 'axios';
import Constants from '@/constants'

// 创建 axios 实例
const service = axios.create({
  baseURL: Constants.BASE_URL, //process.env.VUE_APP_BASE_API, // FastAdmin 后台 API 地址
  timeout: 5000,
});

// 全局 header
const globalHeaders = {
  'Content-Type': 'application/json',
  // 其他全局 header...
};

// 请求拦截器：添加 token
service.interceptors.request.use(
  config => {
    // 合并全局 header 和局部 header（局部覆盖全局）
    config.headers = { ...globalHeaders, ...config.headers };

    // 从本地存储获取 token（类似 uni.getStorageSync）
    const token = localStorage.getItem('token') || ''; // 从 localStorage 获取 token
    if (token) {
      //config.headers['Authorization'] = `Bearer ${token}`; // FastAdmin 默认使用 Bearer Token
      config.headers.token = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理错误
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Token 失效，跳转到登录页
      localStorage.removeItem('token');
      localStorage.removeItem('nickname');
      localStorage.removeItem('redirectPath');
      window.location.href = '/login';
      console.log("退出了？")
    }
    return Promise.reject(error);//异步的状态转化成失败的状态
  }
);

export default service;